/* Card surface — DESIGN.md §4: white, 1px #efeaf8 border, soft shadow, radius 16. */
export default function Card({ children, padding = 20, style, ...rest }) {
  return (
    <div
      style={{
        background: 'var(--color-bg-card)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-card)',
        boxShadow: 'var(--shadow-card)',
        padding,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  )
}
